import React, { Children, useEffect, useMemo, useState } from "react";
import { IoMdClose } from "react-icons/io";
import AppSelectInput from "../../base-components/AppSelectInput";
import Input from "../../Input";
import {
  useCreateLp,
  useLpOtp,
  useResolveBankName,
} from "../../../sevices/hooks/admin";
import { IOptionType } from "./stepper/AccessPermission";
import {
  StableInfo,
  useStableCoinStore,
  useTransferStore,
} from "../../../store";
import ReactLoading from "react-loading";
import CustomRadioButton from "./CustomRadioButton";
import { GoChevronLeft } from "react-icons/go";
interface ModalProps {
  title: string;
  subtitle: string;
  isOpen: boolean;
  onClose: () => void;
  setVerification: (value: boolean) => void;
}

export type IBank = {
  anchorId: string;
  bankName: string;
  cbnCode: string;
  createdAt: string;
  deletedAt: null | string;
  id: string;
  nipCode: string;
  updatedAt: string;
};
const blockchainData = [
  { label: "Polygon", slug: "polygon", id: 2 },
  { label: "Solana", slug: "solana", id: 3 },
  { label: "TRON (TRC-20)", slug: "tron", id: 4 },
];
const rampData = [
  { label: "On-ramp", slug: "on-ramp", id: 2 },
  { label: "Off-ramp", slug: "off-ramp", id: 3 },
];

const AddStableLpModal: React.FC<ModalProps> = ({
  title,
  isOpen,
  onClose,
  subtitle,
  setVerification,
}) => {
  const overLayRef = React.useRef(null);
  const handleOverLayClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    if (e.target === overLayRef.current) {
      onClose();
    }
  };

  const reqOtp = useLpOtp();

  const [LP, setLP] = useState("");
  const [blockChain, setBlockChain] = useState<IOptionType>(null);
  const [ramp, setRamp] = useState<IOptionType>(null);
  const [loading, setLoading] = useState(false);
  const [wallet, setWallet] = useState(false);
  const [walletAddress, setWalletAddress] = useState("");

  const setStableInfo = useStableCoinStore((state) => state.setStableInfo);
  const [selectedOption, setSelectedOption] = useState(`${ramp?.slug} USDC`);
  const userDetails = JSON.parse(localStorage.getItem("user") as string);

  const handleOptionChange = (option: string) => {

    setSelectedOption(option);
    // queueMicrotask(() => {
    console.log(selectedOption, "selectedOption");
    // });
  };

  const stableInfo: StableInfo = {
    name: LP,
    walletType: selectedOption.split(" ")[1],
    ramp: ramp ? ramp?.slug : "",
    blockchain: blockChain ? blockChain?.slug : "",
    walletAddress: walletAddress,
    selected: true,
    otp: "",
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setWallet(true);
  };



  const handleSubmitform = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    setStableInfo(stableInfo);
    reqOtp
      .mutateAsync({ email: userDetails.email })
      .then((res) => {
        setVerification(true);
        setLoading(false);
        console.log(res);
      })
      .catch((err) => {
        alert("something went wrong");
        setLoading(false);
      });
  };

  return (
    <>
      {isOpen ? (
        <div className="modal  fixed w-full h-full top-0 left-0 justify-center items-center transition-opacity duration-300 z-50">
          <div
            ref={overLayRef}
            className="modal_overlay absolute top-0 right-0 flex justify-end w-full h-full cursor-pointer bg-[#13111173]"
            onClick={handleOverLayClick}
          >
            <div className="modal_box relative bg-[#fff] h-full w-[400px] right-0 rounded-l-lg">
              <div className="">
                {wallet && (
                  <div
                    onClick={() => setWallet(false)}
                    className="close absolute top-1 left-1 flex items-center justify-center rounded-full
                hover:bg-slate-200 p-3 hover:rounded-full hover:text-center "
                  >
                    <span className="hover:rotate-90 hover:transform  transition duration-150 ease-in-out">
                      <GoChevronLeft size={29} className="" />
                    </span>
                  </div>
                )}
                <div>
                  <div
                    onClick={() => {
                      onClose();
                      setWallet(false);
                    }}
                    className="close absolute top-1 right-1 flex items-center justify-center rounded-full
                hover:bg-slate-200 p-3 hover:rounded-full hover:text-center "
                  >
                    <span className="hover:rotate-90 hover:transform  transition duration-150 ease-in-out">
                      <IoMdClose size={29} className="" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="title pt-20 px-5">
                <h1 className="text-xl  text-[#071827]">
                  {" "}
                  {!wallet ? title : "Add Stablecoin Wallet"}
                </h1>
                <p className="text-base font-medium text-[#5C6F7F]">
                  {subtitle}
                </p>
              </div>
              <div className="modal_content mx-5 relative h-full">
                {!wallet ? (
                  <form className="space-y-3" onSubmit={handleSubmit}>
                    <div className="mt-3">
                      <Input
                        label={"Liquidity partner name"}
                        name={"name"}
                        type={"text"}
                        onChange={(e: any) => setLP(e.target.value)}
                      />
                    </div>

                    <div className="mt-3">
                      <AppSelectInput
                        options={rampData || []}
                        label=""
                        placeholder="Select ramp"
                        handleChange={(ramp: any) => {
                          setRamp(ramp);
                        }}
                      />
                    </div>

                    <div className="w-full  absolute bottom-52">
                      <div className="w-full  ">
                        <button
                          disabled={ramp === null}
                          className="text-[#fff] bg-[#0eb683]  w-full py-3 rounded-md  active:scale-90 transition-all disabled:opacity-1"
                        >
                          Continue
                        </button>
                      </div>
                    </div>
                  </form>
                ) : (
                  <form className="space-y-3" onSubmit={handleSubmitform}>
                    <div className="mt-3">
                      <h1 className=" text-[14px] leading-[19.2px] mb-2 text-[#5C6F7F]">
                        Wallet Type
                      </h1>
                      <CustomRadioButton
                        onRampLabel={`${ramp?.slug} USDC`}
                        offRampLabel={`${ramp?.slug} USDT`}
                        onChange={handleOptionChange}
                      />
                    </div>
                    <div className="mt-3">
                      <AppSelectInput
                        options={blockchainData || []}
                        label=""
                        placeholder="Blockchain Name"
                        handleChange={(blockChain: any) => {
                          setBlockChain(blockChain);
                        }}
                      />
                    </div>
                    <div className="mt-3">
                      <Input
                        label={`Liquidity Partner USDC Wallet Address`}
                        name={"name"}
                        type={"text"}
                        onChange={(e: any) => setWalletAddress(e.target.value)}
                      />
                    </div>

                    <div className="w-full  absolute bottom-52">
                      <div className="w-full  ">
                        <button
                          type="submit"
                          className="text-[#fff] bg-[#0eb683]  w-full py-3 rounded-md  active:scale-90 transition-all"
                        >
                          {loading ? (
                            <div className="xxs:ml-14 md:ml-[68px]">
                              <ReactLoading
                                type="spinningBubbles"
                                color="#fff"
                                height="27px"
                                width="27px"
                              />
                            </div>
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default AddStableLpModal;
